import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';
import { useAuthStore } from '@/store/authStore';

export interface PropuestaSocketHandlers {
  onHitoChanged?: (payload: {
    hitoId: string;
    parentType: string;
    parentId: string;
    done: boolean;
    estado: 'pendiente' | 'on_track' | 'bloqueado' | 'suspendido' | 'entregado';
    isFormal: boolean;
    isClave: boolean;
    updatedBy: string | null;
    updatedAt: string;
  }) => void;
}

/**
 * Conecta al WS y une al room de una Propuesta.
 * Cuando cualquier colega marca/cambia un hito, llega el evento `hito.changed`.
 */
export function usePropuestaSocket(propuestaId: string | undefined, handlers: PropuestaSocketHandlers) {
  const token = useAuthStore((s) => s.token);
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (!propuestaId || !token) return;

    const socket = io({
      path: '/ws',
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    socket.on('connect', () => {
      socket.emit('propuesta.join', { propuestaId });
    });

    if (handlers.onHitoChanged) socket.on('hito.changed', handlers.onHitoChanged);

    socketRef.current = socket;
    return () => {
      socket.emit('propuesta.leave', { propuestaId });
      socket.disconnect();
      socketRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propuestaId, token]);

  return socketRef;
}
